import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { TranslateService } from "@ngx-translate/core";

@Pipe({ name: 'localizedDate', pure: false })
export class LocalizedDate implements PipeTransform {
  constructor(private translateService: TranslateService) { }

  transform(value: Date | string, format = 'longDate'): any {
    const dataPipe = new DatePipe(this.translateService.currentLang || 'it');
    return dataPipe.transform(value, format);
  }
}